import { useSelector } from 'react-redux'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { Translation } from '@/components/i18n/Translation'
import { LocalDate } from '@/components/LocalDate'
import DataPoint, { DataPoints } from '@/components/primitives/DataPoint'
import { getFrameAgreement } from '@/ducks/customerReducer'

import './current-frame.scss'

const CurrentFrame = () => {
  const {
    granted_amount = 0,
    used = 0,
    approval_date,
    expiration_date,
  } = useSelector(getFrameAgreement)
  const remaining = granted_amount - used

  if (granted_amount === 0) return null
  return (
    <div className="current-frame">
      <DataPoints>
        <DataPoint
          header={<Translation id="Current Frame" />}
          value={<FormattedNumberWithCurrency amount={granted_amount} />}
        />
        <DataPoint
          header={<Translation id="Credit Used" />}
          value={<FormattedNumberWithCurrency amount={used} />}
        />
        <DataPoint
          header={<Translation id="Credit Remaining" />}
          value={<FormattedNumberWithCurrency amount={remaining} />}
        />
        <DataPoint
          header={<Translation id="Period" />}
          value={
            <>
              <LocalDate date={approval_date} /> - <LocalDate date={expiration_date} />
            </>
          }
        />
      </DataPoints>
    </div>
  )
}

export default CurrentFrame
